module.exports = {
      id: "line-arrow-prev-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#line-arrow-prev",
      toString: function () {
        return this.url;
      }
    }